import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";

interface SearchBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  courseType: "theory" | "practical" | "individual";
}

const SearchBar = ({ searchTerm, onSearchChange, courseType }: SearchBarProps) => {
  return (
    <div className="flex items-center mb-6 w-full max-w-sm">
      <Input
        placeholder={`Search ${courseType} courses...`}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="flex-1"
      />
      <Button variant="outline" size="icon" className="ml-2">
        <Search className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default SearchBar;
